import { get, post } from "../axios/http"

export const NumberMessage = () => get('/api/notice/count');
export const NumberMessageClear = (data) => post('api/notice/clear',data);

export const MessageList = () => get('/api/notice/list')

export const getTaskDetail = (daskid) => get(`/api/automations/task/detail?id=${daskid}`)
export const getWorksheetInfo = (worksheetId) => get(`/api/app/worksheet/info/get?id=${worksheetId}`)
export const getRow= (worksheetId, rowId) => get(`/api/app/worksheet/rows/get?worksheetId=${worksheetId}&rowId=${rowId}`)

export const updateRow = (data) => post('api/app/worksheet/rows/update',data)
export const updateTask = (data) => post('api/automations/task/update',data)

export const getAppAuth = (appId) => get(`/api/v2/User/getAppAuth?visualId=${appId}`)